<template>
  <Modal
    v-model="visiable"
    :z-index="5001"
    title="自定义列"
    :width="720"
    :mask-closable="false"
    class-name="c-custom-columns vertical-center-modal"
    @on-cancel="onActionCancel"
  >
    <Row :gutter="12">
      <Col span="15" style="max-height: 400px; overflow: auto">
        <template v-if="basic && basic.length">
          <Row class="row-item row-clearfix" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">
              <span class="item-field">{{ subTitle[0] }}</span>
            </Col>
            <Col span="19">
              <Checkbox :value="bcheckAll" @click.prevent.native="handleCheckAll('basic')">全选</Checkbox>
            </Col>
          </Row>
          <Row class="row-item" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">&nbsp;</Col>
            <Col span="19">
              <Checkbox v-for="(tag, id) in basic" :key="id" v-model="tag.checked">
                {{ tag.title }}
              </Checkbox>
            </Col>
          </Row>
        </template>
        <template v-if="disabled && disabled.length">
          <Row class="row-item row-clearfix" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">
              <span class="item-field">{{ subTitle[0] }}</span>
            </Col>
            <Col span="19">
              <Checkbox :value="dcheckAll" disabled @click.prevent.native="handleCheckAll('disabled')">全选</Checkbox>
            </Col>
          </Row>
          <Row class="row-item" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">&nbsp;</Col>
            <Col span="19">
              <Checkbox v-for="(tag, id) in disabled" :key="id" v-model="tag.checked" disabled>{{ tag.title }}</Checkbox>
            </Col>
          </Row>
        </template>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[1]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[1] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="rcheckAll" @click.prevent.native="handleCheckAll('report')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[1]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox v-for="(tag, id) in report" :key="id" v-model="tag.checked">{{ tag.title }}</Checkbox>
          </Col>
        </Row>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[2]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[2] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="ocheckAll" @click.prevent.native="handleCheckAll('other')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[2]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox v-for="(tag, id) in other" :key="id" v-model="tag.checked">{{ tag.title }}</Checkbox>
          </Col>
        </Row>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[3]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[3] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="acheckAll" @click.prevent.native="handleCheckAll('analysis')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[3]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox v-for="(tag, id) in analysis" :key="id" v-model="tag.checked">{{ tag.title }}</Checkbox>
          </Col>
        </Row>
      </Col>
      <Col span="8" offset="1" class="r-box">
        <div class="box-head">
          <span>拖动排序 {{ draggableModel.filter((ret) => ret.checked).length }} 列</span>
          <el-button type="text" @click="clear">清空全部</el-button>
        </div>
        <div class="box-body">
          <draggable v-model="draggableModel">
            <transition-group>
              <span v-for="item in draggableModel" :key="item.key">
                <!-- 只显示勾选的 -->
                <Tag v-if="item.checked" :name="item.key" closable @on-close="handleClose">{{ item.title }}</Tag>
              </span>
            </transition-group>
          </draggable>
        </div>
      </Col>
    </Row>
    <div slot="footer">
      <Button type="default" @click="onActionCancel">取消</Button>
      <Button type="primary" @click="onSortConfirm">应用</Button>
    </div>
  </Modal>
</template>
<script>
import draggable from 'vuedraggable'
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, deepCopy } from '@/common/js/utils'
export default {
  name: 'customColumn',
  components: { draggable },
  props: {
    value: {
      type: Boolean
    },
    // 获取自定义列的storage key
    name: {
      type: String
    },
    data: {
      type: Array
    },
    subTitle: {
      type: Array,
      default() {
        return ['计划数据', '报表数据', '其他数据', '分析数据']
      }
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    draggableModel: {
      get() {
        const columns = this.disabled?.length ? this.columns.filter((ret) => ret.type !== 'disabled') : this.columns
        // 只显示非隐藏、非固定列
        return columns.filter((ret) => !ret.fixed && ret.type)
      },
      set(val) {
        // 原表格列根据新的顺序排序
        const sortOrders = val.map((v) => v.key)
        this.columns.sort((a, b) => sortOrders.indexOf(a.key) - sortOrders.indexOf(b.key))
      }
    },
    basic() {
      return this.columns.filter((ret) => ret.type === 'basic')
    },
    report() {
      return this.columns.filter((ret) => ret.type === 'report')
    },
    other() {
      return this.columns.filter((ret) => ret.type === 'other')
    },
    analysis() {
      return this.columns.filter((ret) => ret.type === 'analysis')
    },
    disabled() {
      const disabledArr = this.columns.filter((ret) => ret.type === 'disabled')
      disabledArr.forEach((item) => {
        this.$set(item, 'checked', false)
      })
      return disabledArr
    },
    bcheckAll() {
      return this.basic.every((ret) => ret.checked)
    },
    rcheckAll() {
      return this.report.every((ret) => ret.checked)
    },
    ocheckAll() {
      return this.other.every((ret) => ret.checked)
    },
    acheckAll() {
      return this.analysis.every((ret) => ret.checked)
    },
    dcheckAll() {
      // return this.disabled.every(ret => !ret.show)
      return true
    }
  },
  created() {
    this.initCustomerCols()
  },
  methods: {
    initCustomerCols() {
      const cols = this.getLocalTableCols()
      this.columns = cols
      this.onSortConfirm()
    },
    getLocalTableCols() {
      const localResults = this.getCustomStorage(this.name)
      if (localResults) {
        const localTableCols = localResults.map((res) => {
          const [key, width] = res.split('|')
          // 获取缓存的列宽，获取不到的为0
          const colWidth = Number(width)
          return { key, width: Object.is(colWidth, NaN) ? 0 : colWidth }
        })

        const localKeys = localTableCols.map((l) => l.key)

        // 生成一个全部表格列长度的数组
        const newCols = []

        this.data.forEach((col, index) => {
          const colIndex = localTableCols.findIndex((localCol) => localCol.key === col.key)
          // 本地缓存存在的列
          if (colIndex > -1) {
            const localCol = localTableCols[colIndex]
            const c = { ...col, ...localCol, checked: true }

            // 有些没有缓存表格列宽的，使用外部配置的
            if (!c.width) c.width = col.width
            newCols.splice(index, 0, c)
          } else {
            // 新增或隐藏的列，默认不勾选
            const c = { ...col, checked: false }
            newCols.push(c)

            // 把本地缓存不存在的列，放置在原本位置，使localKeys数组长度 = this.data的数组长度，便于后面排序
            localKeys.splice(index, 0, c.key)
          }
        })
        newCols.sort((a, b) => localKeys.indexOf(a.key) - localKeys.indexOf(b.key))
        return newCols
      }

      const cols = this.data.map((col) => ({ ...col, checked: true }))
      return cols
    },
    makeStorageArr() {
      const arr = this.columns
        .filter((col) => col.checked)
        .map((col) => {
          const width = Number(col.width)
          if (!width || Object.is(width, NaN)) return col.key
          return `${col.key}|${width}`
        })
      return arr?.length ? arr : []
    },
    onActionCancel() {
      this.columns = this.rawColumns
      this.$emit('input', false)
    },

    onSortConfirm() {
      const localCols = this.makeStorageArr()
      this.setCustomStorage(this.name, localCols)
      this.rawColumns = deepCopy(this.columns)
      this.$emit('on-select', deepCopy(this.columns))
    },
    /**
     * @description: 拖动表头更新列宽外部组件ref调用
     * @param {*} newWidth
     * @param {*} column
     */
    updateTableColWidth(newWidth, column) {
      const localCols = this.makeStorageArr()
      const newLocalCols = localCols.map((col) => {
        if (col.includes(`${column.property}|`)) {
          return `${column.property}|${parseInt(newWidth)}`
        }
        return col
      })
      this.setCustomStorage(this.name, newLocalCols)
    },
    handleCheckAll(name) {
      let v
      if (name === 'basic') v = this.bcheckAll
      else if (name === 'report') v = this.rcheckAll
      else if (name === 'other') v = this.ocheckAll
      else if (name === 'analysis') v = this.acheckAll
      else if (name === 'disabled') v = this.dcheckAll
      this[name].forEach((ret, i) => {
        this.$set(ret, 'checked', !v)
      })
    },
    handleClose(e, name) {
      this.columns = this.columns.map((col) => {
        if (col.key === name) {
          return { ...col, checked: false }
        }
        return col
      })
    },
    clear() {
      this.columns = this.columns.map((col) => {
        // 由于没有col.type的列不会显示，所以表格列不需要处理，默认显示
        if (!col.type) {
          return { ...col, checked: true }
        }

        return { ...col, checked: false }
      })
    },
    getCustomStorage(name) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name)
      if (storage && isArray(storage[account])) return storage[account]
      else return null
    },
    setCustomStorage(name, list) {
      const account = Cookies.get('ch_op_id')
      let storage = getLocal(name)
      if (!storage) storage = {}
      storage[account] = list
      setLocal(name, storage)
    }
  },
  data() {
    return {
      columns: [], // 自定义列表数据
      rawColumns: []
    }
  }
}
</script>
<style lang="scss" scoped>
.c-custom-columns {
  padding: 12px 0;

  .r-box {
    width: 200px;

    .box-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .box-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      max-height: 395px;

      ::v-deep .ivu-tag {
        width: 160px;
        user-select: none;

        i.ivu-icon-ios-close {
          float: right;
          display: inline-block;
          margin-top: 4px;
          margin-right: -2px;
        }
      }
    }
  }

  /* 表单选项 */
  .row-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 32px;

    .col-item {
      text-align: right;
    }

    i {
      margin-right: 4px;
      vertical-align: middle;

      &.ivu-icon-md-add {
        margin: 0;
      }
    }

    .item-field {
      font-size: 14px;
      padding-right: 12px;
      white-space: nowrap;
    }
  }

  .row-clearfix {
    clear: both;
    margin-bottom: 12px;
  }
}
</style>
